const binding = { modules: {}, dataActions: {} };

    (binding.modules['mil-form-embed'] = {
        c: () => require('partner/modules/mil-form-embed/mil-form-embed.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'mil-form-embed',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/mil-form-embed'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|mil-form-embed|mil-form-embed'] = {
                c: () => require('partner/modules/mil-form-embed/mil-form-embed.view.tsx'),
                cn: '__local__-__local__-mil-form-embed'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };